import { get } from '~/services/donationScreen';
import type { OrgInfoApiResponse } from '~/types';

let cachedData: OrgInfoApiResponse | null = null;
let pendingPromise: Promise<OrgInfoApiResponse> | null = null;

export const getCachedOrgInfo = async (): Promise<OrgInfoApiResponse> => {
  if (cachedData) return cachedData;
  if (pendingPromise) return pendingPromise;

  pendingPromise = get<OrgInfoApiResponse>('/v1/get_org_info').then(response => {
    cachedData = response.data;
    pendingPromise = null;
    return cachedData;
  });

  return pendingPromise;
};

export const clearOrgInfoCache = () => {
  cachedData = null;
  pendingPromise = null;
};
